import { render, staticRenderFns } from "./TopicsItem.vue?vue&type=template&id=2d0bcb9a&scoped=true&"
import script from "./TopicsItem.vue?vue&type=script&lang=js&"
export * from "./TopicsItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicsItem.vue?vue&type=style&index=0&id=2d0bcb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bcb9a",
  null
  
)

export default component.exports